<template>
   <div class="row">
      <div class="col-12">
         <button type="button" class="btn float-left mt-1 ml-auto" :class="currentClass" @click.stop="onAction" >
            {{text}}
         </button>
      </div>
   </div>
</template>

<script>
export default {
   props: {
      btnClass: {
         type: [String],
         default: "info"
      },
      text: {
         type: [String],
         required: true
      }
   },
   data() {
      return {
      }
   },
   computed: {
      currentClass(){
         return `btn-${this.btnClass}`
      }
   },
   methods: {
      async onAction(){
         await this.$emit("on-action")
      }
   }
}
</script>